// export const serverUrl = "http://65.1.191.108:8080/"; // MYSQL
// export const serverUrl = 'http://192.168.15.37:8080/';
// export const serverUrl = "http://10.0.0.29:38080/"; // YOGESH
// export const serverUrl = "http://10.0.0.132:9009/"; // CK Airtel
// export const serverUrl = "http://172.20.10.11:8080/"; // CK iPhone

import { environment } from "src/environments/environment";

// export const serverUrl = "http://172.20.10.14:8080/"; // Om iPhone
export const serverUrl = environment.REGISTRATION_URL;
// export const serverUrl = "http://65.1.196.115:8085/"; // Oracle
// export const serverUrl = "https://masterilms.mhada.gov.in/";

// export const serverUrl = "https://lotterybackendprod.mhada.gov.in/"; // Production
// ILMS(CK_IPHONE)_1409_1207PM
